(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sf-live-offers"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-copy-offer]');
    if (!button) return;
    const code = button.closest('.sf-offer-card__code-row').querySelector('[data-offer-code]').textContent.trim();
    await navigator.clipboard.writeText(code);
    const original = button.textContent;
    button.textContent = button.dataset.copiedLabel;
    window.setTimeout(() => { button.textContent = original; }, 1600);
  });

  } catch(e) { console.error(e); }
})();
})();
